// @flow

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import ResetPasswordConfirmation from './ResetPasswordConfirmation';
import ValidationService from '../../../lib/validation';
import { resetPasswordRequest } from '../../../modules/Authentication/actions';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';

const validate = values => ({
  password: ValidationService.validatePassword(values.password),
});

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'resetPasswordConfirmation'),
});

const mapDispatchToProps = {
  onSubmit: resetPasswordRequest,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({ form: 'resetPasswordConfirmation', validate })
);

export default enhance(ResetPasswordConfirmation);
